module.exports = __webpack_public_path__ + "media/applicants/icon-lock-c1132a98.png";